export default {
  scopes: { method: 'post', url: 'v1/movida/profile/scopes' },
}